//
//
//
//
//
//
//
//
//
//

export default {
  name: "Szoperation",
};
